import { Monitor, HardDrive, Cpu, MemoryStick, Mouse, Keyboard, Laptop, Headphones } from 'lucide-react';

export const PRODUCT_CATEGORIES = {
  title: "Shop by Category",
  mainCategories: [
    { name: 'Monitors', slug: '/category/best-computer-monitors', icon: Monitor, 
      tags: [
        { name: '4K Monitor', slug: '/category/best-computer-monitors/4k' },
        { name: 'Gaming Monitor', slug: '/category/best-computer-monitors/gaming' },
        { name: 'Ultrawide Monitor', slug: '/category/best-computer-monitors/ultrawide' },
        { name: '240Hz Monitor', slug: '/category/best-computer-monitors/240Hz' },
      ],
      brands: [
        { name: 'Dell', slug: '/category/best-computer-monitors/dell' },
        { name: 'LG', slug: '/category/best-computer-monitors/lg' },
        { name: 'Samsung', slug: '/category/best-computer-monitors/samsung' },
        { name: 'ASUS', slug: '/category/best-computer-monitors/ASUS' },
        { name: 'Acer', slug: '/category/best-computer-monitors/acer' },
      ],
      promo: {
        title: "Crystal Clear Views",
        description: "Upgrade your display with up to 30% off on 4K monitors.",
        link: "/deals/monitors",
        imageUrl: "https://placehold.co/400x600/3b82f6/ffffff?text=4K+Monitor"
      }
    },
    { name: 'Graphics Cards', slug: '/category/best-graphics-cards-gpu', icon: HardDrive,
       tags: [
        { name: 'NVIDIA', slug: '/category/best-graphics-cards-gpu/nvidia' },
        { name: 'AMD', slug: '/category/best-graphics-cards-gpu/amd' },
        { name: 'Ray Tracing', slug: '/category/best-graphics-cards-gpu/ray-tracing' },
        { name: '8GB+ VRAM', slug: '/category/best-graphics-cards-gpu/8gb-vram' },
      ],
      brands: [
        { name: 'ASUS', slug: '/category/best-graphics-cards-gpu/asus' },
        { name: 'Gigabyte', slug: '/category/best-graphics-cards-gpu/gigabyte' },
        { name: 'MSI', slug: '/category/best-graphics-cards-gpu/msi' },
      ],
      promo: {
        title: "Unleash Peak Performance",
        description: "Next-gen gaming starts with a powerful GPU.",
        link: "/deals/gpus",
        imageUrl: "https://placehold.co/400x600/10b981/ffffff?text=GPU"
      }
    },
    { name: 'Processors (CPU)', slug: '/category/best-processors-cpu', icon: Cpu,
        tags: [
            { name: 'Intel Core i9', slug: '/category/best-processors-cpu/intel-i9' },
            { name: 'AMD Ryzen 9', slug: '/category/best-processors-cpu/amd-ryzen-9' },
            { name: 'Overclockable', slug: '/category/best-processors-cpu/overclocking' },
        ],
        brands: [
            { name: 'Intel', slug: '/category/best-processors-cpu/intel' },
            { name: 'AMD', slug: '/category/best-processors-cpu/amd' },
        ],
        promo: {
            title: "The Brains of Your Rig",
            description: "Find the perfect CPU for gaming and productivity.",
            link: "/deals/cpus",
            imageUrl: "https://placehold.co/400x600/8b5cf6/ffffff?text=CPU"
        }
    },
    { name: 'Memory (RAM)', slug: '/category/fastest-gaming-ram-memory', icon: MemoryStick,
      tags: [
        { name: 'DDR5', slug: '/category/fastest-gaming-ram-memory/ddr5' },
        { name: 'DDR4', slug: '/category/fastest-gaming-ram-memory/ddr4' },
        { name: 'RGB', slug: '/category/fastest-gaming-ram-memory/rgb-ram' },
      ],
      brands: [
        { name: 'Corsair', slug: '/category/fastest-gaming-ram-memory/corsair' },
        { name: 'G.Skill', slug: '/category/fastest-gaming-ram-memory/gskill' },
      ],
      promo: {
          title: "Speed Up Your System",
          description: "Blazing fast RAM kits are on sale now.",
          link: "/deals/ram",
          imageUrl: "https://placehold.co/400x600/ef4444/ffffff?text=RAM"
      }
    },
    { name: 'Gaming Mice', slug: '/category/best-gaming-mice', icon: Mouse,
      tags: [],
      brands: [],
      promo: {
          title: "Precision in Your Palm",
          description: "Get the competitive edge with our top-rated gaming mice.",
          link: "/deals/mice",
          imageUrl: "https://placehold.co/400x600/f97316/ffffff?text=Mouse"
      }
    },
    { name: 'Keyboards', slug: '/category/best-mechanical-keyboards', icon: Keyboard,
        tags: [],
        brands: [],
        promo: {
            title: "Click, Clack, Conquer",
            description: "Mechanical keyboards for the ultimate typing experience.",
            link: "/deals/keyboards",
            imageUrl: "https://placehold.co/400x600/ec4899/ffffff?text=Keyboard"
        }
    },
    { name: 'Gaming Headsets', slug: '/category/best-gaming-headsets', icon: Headphones,
        tags: [],
        brands: [],
        promo: {
            title: "Click, Clack, Conquer",
            description: "Gaming Headsets for the ultimate typing experience.",
            link: "/deals/headsets",
            imageUrl: "https://placehold.co/400x600/ec4899/ffffff?text=headsets"
        }
    },
    { name: 'Gaming Laptops', slug: '/category/best-laptops-for-gaming', icon: Laptop,
        tags: [],
        brands: [],
        promo: {
            title: "Click, Clack, Conquer",
            description: "Gaming Laptops for the ultimate typing experience.",
            link: "/deals/laptop",
            imageUrl: "https://placehold.co/400x600/ec4899/ffffff?text=Laptop"
        }
    },
  ],
};